import React from 'react';
import AuthenticatedOnly from "./containers/AuthenticatedOnly";
import HeaderContainer from "./containers/HeaderContainer";
import ContentContainer from "./containers/ContentContainer";
import {Route, Switch} from "react-router";
import RewardsOverviewPage from "./containers/RewardsOverviewPage";
import FaqContainer from "./containers/FaqContainer";
import ContactPage from "./containers/ContactPage";
import OrderDetailPage from "./containers/OrderDetailPage";
import RewardDetailPage from "./containers/RewardDetailPage";
import AppWithGlobalErrorHandling from "./containers/AppWithGlobalErrorHandling ";
import FooterContainer from "./containers/FooterContainer";
import FormPage from "./containers/FormPage";

class App extends React.Component {

    render() {
        return <AuthenticatedOnly>
            <HeaderContainer/>
            <ContentContainer>
                <AppWithGlobalErrorHandling>
                    <Switch>
                        <Route path="/" exact component={RewardsOverviewPage}/>
                        <Route path="/faq" exact component={FaqContainer}/>
                        <Route path="/contact" exact component={ContactPage}/>
                        <Route path="/order/:orderId" exact component={OrderDetailPage}/>
                        <Route path="/form/:formFriendlyName" exact component={FormPage}/>
                        <Route path="/:friendlyName" component={RewardDetailPage}/>
                    </Switch>
                </AppWithGlobalErrorHandling>
            </ContentContainer>
            <FooterContainer/>
        </AuthenticatedOnly>;
    }

}

export default App;

